import { Validators } from '@angular/forms';
import {
  CustomValidator, fmcValidator,
  noWhitespaceValidator
} from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';
import {defaultFieldConfig} from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';

export class CompanyDetailsModel {
  companyList = {
    value: [],
    validation: Validators.compose([])
  };
}

export class IndividualCompanyModel {
  partyRoleId = {
    value: null,
    validation: Validators.compose([])
  };
  partyId = {
    value: null,
    validation: Validators.compose([])
  };
  companyName = {
    value: null,
    validation: Validators.compose([
      noWhitespaceValidator,
      Validators.required
    ])
  };
  companyABN = {
    value: null,
    validationAsync: [fmcValidator('abn')]
  };
  companyDescription = {
    value: null,
    validation: Validators.compose([
    ])
  };
  companyACN = {
    value: null,
    validationAsync: [fmcValidator('acn')]
  };
  tradingName = {
    value: null,
    validation: Validators.compose([
    ])
  };
  companyContactName = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      CustomValidator.nameValidator(defaultFieldConfig.fullName)
    ])
  };
  companyContactPosition = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  companyContactMobile = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  companyContactEmail = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.email
    ])
  };
  tradingAddress = {
    value: null,
    validation: Validators.compose([])
  };
  postalAddress = {
    value: null,
    validation: Validators.compose([])
  };
  postalAddressAsTrading = {
    value: true,
    validation: Validators.compose([])
  };
  postSettlementAddress = {
    value: true,
    validation: Validators.compose([])
  };
  postSettlementAddressAsTrading = {
    value: true,
    validation: Validators.compose([])
  };
  ext = {
    value: null,
    validation: Validators.compose([])
  };

  // accountant
  companyHasAccountant = {
    value: false,
    validation: Validators.compose([])
  };
  companyAccountantAbn = {
    value: null,
    validationAsync: [fmcValidator('abn')]
  };
  companyAccountantContactName = {
    value: null,
    validation: Validators.compose([
      CustomValidator.nameValidator(defaultFieldConfig.fullName)
    ])
  };
  companyAccountantEmail = {
    value: null,
    validation: Validators.compose([])
  };
  companyAccountantPhone = {
    value: null,
    validation: Validators.compose([])
  };
  trusteeOf = {
    value: null,
    validation: Validators.compose([])
  };

  acnRegistered = {
    value: null,
    validation: Validators.compose([])
  };
  industryType = {
    value: null,
    validation: Validators.compose([])
  };
  contactDetailsAsEntity = {
    value: null,
    validation: Validators.compose([])
  };
  contactSelected = {
    value: null,
    validation: Validators.compose([])
  };
}
